module.exports = __webpack_public_path__ + "static/media/mixkit-car-double-horn-719.63e8a8d3.wav";